import { useEffect, useState } from 'react';
import Modal from '../Modal';
import Link from 'next/link';
import { MdContentCopy, MdOutlineCheck } from 'react-icons/md';
import eventClickShare from 'ui/lib/gtm/eventClickShare';
import Whatsapp from '../Icons/Whatsapp';
import FacebookIcon from '../Icons/FacebookIcon';
import XLogo from '../Icons/Xlogo';
import TiktokIcon from '../Icons/TiktokIcon';
import useIsNativeView from 'ui/hooks/useIsNativeView';
import { Article } from '../../../interface';
import { useDispatch, useSelector } from 'react-redux';
import { promoButtonClickOption } from '../../../helpers/emarsys/promo/eventClickPromo';
import { FEATURE } from '../../../constants/emarsys/branch-sales';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import eventClickDetailBranchSales from '../../../helpers/emarsys/branch-sales/eventClickDetailBranchSales';
import { IRootState } from '../../../store';

export interface ModalShareProps {
  copyLink?: {
    tag?:
      | {
          name?: string;
        }[]
      | {
          tagName?: string;
        };
    startDate?: string;
    endDate?: string;
    titlePage?: string;
    detail?: {
      detailContent?: string;
    };
    detailContent?: string;
  };
  link?: string;
  visible: boolean;
  article?: Article;
  onClose: () => void;
  style?: React.CSSProperties;
  actionClick?: (buttonName: string) => void;
}

declare const window: WindowTypes;

export default function ModalShare({
  copyLink = {},
  visible = false,
  article = {
    altImage: '',
    approvalStatus: '',
    approvedBy: '',
    approvedDate: '',
    articleType: '',
    authorName: '',
    bannerLink: '',
    branch: {
      id: 0,
      branchName: '',
      isocode: '',
      cellphone: '',
      countryName: '',
      defaultAddress: false,
      formattedAddress: '',
      addressId: '',
      line1: '',
      line2: '',
      phone: '',
      postalCode: '',
      shippingAddress: false,
      town: '',
      visibleDdAddressBook: null,
      altText: null,
      isInterior: '',
      url: '',
      displayName: '',
      latitude: 0,
      longitude: 0,
      isShowGetAdvised: false,
      openingHoursCode: '',
      openingHoursName: '',
      plpTestDrive: false,
      type: '',
      branchLandingPage: {
        id: 0,
        branchImageLink: '',
        titleSalesman: '',
        descriptionSalesman: '',
        titleProduct: '',
        descriptionProduct: '',
        titlePurnaJual: '',
        descriptionPurnaJual: '',
        salesConsultantInformation: '',
        description: '',
        branchHeadName: '',
        workshopHeadname: '',
        seoStatus: false,
        seoTitle: '',
        seoSlug: '',
        seoKeyword: '',
        seoDescription: '',
      },
    },
    branchLandingPage: '',
    carModel: '',
    category: {
      description: '',
      id: 0,
      name: '',
      type: '',
    },
    city: {
      id: 0,
      name: '',
      isocode: '',
      cityInformationHeader: '',
      cityInformationDescription: '',
      promoInformationHeader: '',
      promoInformationDescription: '',
      eventInformationHeader: '',
      eventInformationDescription: '',
      dealerInformationHeader: '',
      dealerInformationDescription: '',
      informasiFaqTitle: '',
      informasiCustomerReviewTitle: '',
      seoTitleTag: '',
      seoRobotTag: '',
      seoAltImage: null,
      seoKeyword: '',
      seoMetaDescription: '',
    },
    cityLandingPage: '',
    contentCategory: {
      description: '',
      id: 0,
      name: '',
      priority: '',
    },
    createdBy: '',
    createdDate: '',
    deletedDate: '',
    detail: {
      detailContent: '',
    },
    endDate: '',
    groupType: '',
    heroImageLink: '',
    id: 0,
    isDeleted: false,
    keyword: '',
    metaDescription: '',
    metaRobots: [],
    mobileUrl: '',
    modifiedBy: '',
    modifiedDate: '',
    modifiedReason: '',
    priority: '',
    province: '',
    publishedDate: '',
    rejectedBy: '',
    rejectedDate: '',
    salesman: '',
    salesmanLandingPage: '',
    seoDescription: '',
    seoStatus: false,
    slug: '',
    slugUnique: '',
    startDate: '',
    status: '',
    tag: '',
    titleHeader: '',
    titlePage: '',
    whatsNewSalesmanLandingPage: '',
  },
  onClose = () => {},
  style = {},
  actionClick,
}: ModalShareProps) {
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth) || {
    userData: null,
  };

  const [isCopied, setIsCopied] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');
  const isNativeView = useIsNativeView();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
    }
  }, []);

  const socialMediaShare = (platform: string) => {
    switch (platform) {
      case 'whatsapp':
        return `https://api.whatsapp.com/send?text=${encodeURIComponent(
          (article?.titlePage || '') + ' ' + currentUrl
        )}`;
      case 'facebook':
        return `https://www.facebook.com/share.php?u=${encodeURIComponent(currentUrl)}`;
      case 'x':
        return `https://x.com/intent/tweet?url=${encodeURIComponent(
          currentUrl
        )}&text=${encodeURIComponent(article?.titlePage || '')}`;
      case 'tiktok':
        return `https://www.tiktok.com/@auto2000official`;
      default:
        return '';
    }
  };

  const handleNativeShare = (platform) => {
    if (typeof window !== 'undefined') {
      switch (platform) {
        case 'whatsapp':
          window?.androidApp?.goToWhatsapp();
          window?.webkit?.messageHandlers?.iosApp?.postMessage?.('goToWhatsapp');
          break;
        case 'facebook':
          window?.androidApp?.goToFacebook();
          window?.webkit?.messageHandlers?.iosApp?.postMessage?.('goToFacebook');
          break;
        case 'x':
          window?.androidApp?.goToTwitter();
          window?.webkit?.messageHandlers?.iosApp?.postMessage?.('goToTwitter');
          break;
        case 'tiktok':
          window?.androidApp?.goToTiktok();
          window?.webkit?.messageHandlers?.iosApp?.postMessage?.('goToTiktok');
          break;
        default:
          break;
      }
    }
  };

  const { categoryService } = useSelector((state: any) => state.dataGTM || {});

  const handleClickShare = (copyLink, platform) => {
    handleNativeShare(platform);
    eventClickShare(copyLink, platform, categoryService);
  };

  const handleCopyLink = () => {
    if (typeof window !== 'undefined') {
      window?.androidApp?.goToCopyClipboard();
      window?.webkit?.messageHandlers?.iosApp?.postMessage('goToCopyClipboard');
      eventClickShare(copyLink || article, 'share link', categoryService);
      setIsCopied(true);
      // Cek ketersediaan fitur clipboard sebelum menggunakan
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(window.location.href)
          .then(() => setTimeout(() => setIsCopied(false), 2000))
          .catch((error) => console.error('Clipboard writeText error:', error));
      }
    }
    if (actionClick) {
      actionClick(promoButtonClickOption.shareCopylink);
    }
  };

  return (
    <Modal
      visible={visible}
      header={true}
      onClose={onClose}
      modalClassName="!z-[100]"
      bodyClassName="bg-gray10 p-6"
      className={'!h-[240px] w-[90vw] md:!w-[622px]'}
      title={'Bagikan'}
      btnCloseTestId={'btn-close-modal-share'}
      style={style}
    >
      <div className="flex items-center gap-[26px] justify-center mb-[20px]">
        {['whatsapp', 'facebook', 'x', 'tiktok'].map((platform) => (
          <Link
            key={platform}
            href={socialMediaShare(platform)}
            rel="noopener"
            target="_blank"
            onClick={(e) => {
              if (isNativeView) {
                e.preventDefault();
              }

              if (actionClick) {
                if (promoButtonClickOption?.[platform]) {
                  actionClick(promoButtonClickOption?.[platform]);
                }
              }
              handleClickShare(copyLink || article, platform);
            }}
            id={`btn-share-${platform}`}
            aria-label={`share ${platform} link`}
          >
            {/* Tambahkan ikon sesuai dengan sosial media */}
            {platform === 'whatsapp' && <Whatsapp size="23" fill="#231F20" />}
            {platform === 'facebook' && <FacebookIcon size="23" fill="#231F20" />}
            {platform === 'x' && <XLogo size="23" fill="#231F20" />}
            {platform === 'tiktok' && <TiktokIcon size="23" fill="#231F20" />}
          </Link>
        ))}
      </div>

      <div className="relative">
        <input
          className="w-full p-3 pr-11 text-base text-reliableBlack70 bg-transparent border border-reliableBlack20 rounded-[5px]"
          value={currentUrl}
          disabled
          id={'textLink'}
          aria-label="link input"
        />
        <button
          className="absolute right-3 top-0 bottom-0 m-auto"
          onClick={handleCopyLink}
          id={'btn-copy-link'}
          aria-label="copy button"
        >
          {!isCopied ? (
            <MdContentCopy size={22} color="#E1E1E1" />
          ) : (
            <MdOutlineCheck size={22} color="#4cc0ad" />
          )}
        </button>
      </div>
    </Modal>
  );
}
